<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Introduction
                    </h2>
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-2" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2> </h2>
                    <label for="" class="mt-2">This document outlines the detailed steps for logging into the PayG
                        Sales Partner platform. Follow these instructions carefully to ensure a successful login. </label>
                </div>
                <div class="col-md-12 mt-2  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-4"><b>Step 1: Visit our website at <a> www.payg.in </a>and click on Login As “Sales Partner” </b>
                    </h4>
                    <label for=""></label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src=" ./assets/visitorweb.png" width="100%" height="100%" alt="">
                        </div>
                    </div>


                    <h4 class="mt-4"><b>Step 2: Enter your Email/Phone and Password and click on login</b></h4>
                    <label for=""> </label>


                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src=" ./assets/rr-top(2).svg" width="100%" height="100%" alt=""> 
                        </div>
                    </div>

                    <h4 class="mt-4"><b>Step 3: Your OTP will be sent to your PayG RMS app. If you don’t have the app,
                            first download PayG RMS app and then login in your app to get the OTP</b></h4>
                    <label for=""></label>

                    <div class="row">
                        <div class="col-md-12 mt-3">
                             <img src="./assets/Screenshot 2024-10-30 123903.png" width="100%" height="100%" alt=""> 
                            <label class="mt-2 mb-2">Download the PayG RMS app from the Play Store. </label>

                        </div>
                    </div>

                    <h4 class="mt-5"><b>Step 4:Check the app for OTP. When you login to your app it will directly show
                            you your OTP with a pop-up notification</b></h4>
                    <label for=""> </label>

                    <div class="row">
                        <div class="col-md-12 mt-3" style="text-align: center;">
                             <img src=" ./assets/rr-otp(4).svg" width="200px" height="400px" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4"><b>Step 5:Enter the OTP you got on your app on the web to login</b></h4>

                    <label for=""> </label>


                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src=" ./assets/rr-orp(5).svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4">After entering the OTP, you will login to your dashboard </h4>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src=" ./assets/rr-otp(6).svg" width="100%" height="100%" alt=""> 
                        </div>
                    </div>
                    <h4 class="mt-4">Note: If you didn’t see the OTP on the dashboard. Click on left handside on profile
                        and then click on “View OTP” </h4>
                    <div class="row">
                        <div class="col-md-12 mt-3" style="text-align: center;">
                            <img src=" ./assets/rr-otp(7).svg" width="200px" height="400px" alt=""> 
                        </div>
                    </div>

                    <label class="mt-3">You have now successfully navigated the login process for the PayG RMS platform using the
                        app. If you encounter any issues, please refer to the support section of the app or contact
                        customer support for assistance. </label>


                </div>
            </div>
        </div>
    </div>

    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">Introduction </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Login  Process with OTP </span>

                            </div>
                        </div>
                    </a>
                </div>
                <!-- <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Benefits of Being a Sales Partner </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')"> How Sales Partners Can Benefit from PayG</span>

                            </div>
                        </div>
                    </a>
                </div> -->

            </div>
        </div>
    </div>

    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/login-with-qr']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;Login with QR
                        &nbsp;</button></a>
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/payment-link']"> <button class="btn btn-color">Payment link
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>